import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * React translation of the old {@code pages/product/schaeffProductLayoutPage.jsp}.
 *
 * Structure-copy parity (slot order, body placement, and JSP wrapper ids/classes
 * are preserved from the JSP):
 *
 * <ol>
 *   <li>the route body at the {@code #pdpPage_root} position, replacing the
 *     former {@code ProductDetailsPage} React island mount that the deleted JSP
 *     placed via {@code window.SCHA.createComponentAtId(...)}.</li>
 *   <li>a SmartEdit-only {@code PDPFormSlot} conditional, driven by the current
 *     page metadata's {@code smartEdit} identity.</li>
 * </ol>
 *
 * The former JSP-local {@code window.productDesignation} global is not
 * translated here. The calculation-tab script is loaded by the tab from the
 * PDP page-data contract. The {@code markUpLdJson} JSON-LD concern stays in
 * the controller head/SEO path (out of 0153 scope).
 *
 * Registered under the real backend {@code templateUid} {@code ProductPageTemplate}.
 */
export function ProductPageTemplate({ metadata, slots, body }: PageTemplateProps) {
  const isInSmartEdit = Boolean(metadata.smartEdit);

  return (
    <>
      <div id="pdpPage_root">{body}</div>
      {isInSmartEdit && slots.renderSlot("PDPFormSlot")}
    </>
  );
}
